import type { StateStore } from "../app/state/StateStore";
import type { GapElementModel } from "../elements/GapElement";

import { BaseBlock } from "./BaseBlock";

import { GapElement } from "../elements/GapElement";

/**
 * Block задания с пропусками.
 */
export class GapBlock extends BaseBlock {

    private readonly task: any;

    private readonly taskIndex: number;

    private readonly store: StateStore;

    private readonly elements =
        new Map<number, GapElement>();

    constructor(
        task: any,
        taskIndex: number,
        store: StateStore
    ) {

        super();

        this.task = task;
        this.taskIndex = taskIndex;
        this.store = store;

    }

    public override mount(): void {

        this.root = this.render();

        super.mount();

    }

    public override update(): void {

        const newRoot =
            this.render();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public override unmount(): void {

        for (const element of this.elements.values()) {
            element.unmount();
        }

        this.elements.clear();

        super.unmount();

    }

    private render(): HTMLElement {

        const wrapper = document.createElement("div");

        wrapper.className =
            "task gap-task card";

        wrapper.innerHTML = this.task.html;

        const gapNodes =
            wrapper.querySelectorAll<HTMLElement>(".krok-gap");

        gapNodes.forEach(node => {

            const gapId = Number(node.dataset.gapId);

            if (!this.task.gaps[gapId]) {
                return;
            }

            const element =
                new GapElement(
                    this.createGapModel(gapId)
                );

            element.mount();

            this.elements.set(
                gapId,
                element
            );

            node.replaceWith(
                element.getRoot()
            );

        });

        const button =
            document.createElement("button");

        button.addEventListener(
            "click",
            () => {

                this.toggleReveal();

            }
        );

        button.className = "gap-btn";

        button.textContent =
            this.store.getState().revealed[this.taskIndex]
                ? "Зробити ще раз"
                : "Відповідь";

        wrapper.appendChild(button);

        return wrapper;

    }

    private updateGapValue(
        gapId: number,
        value: string
    ): void {

        this.store.updateSilently(prev => ({

            ...prev,

            gaps: {

                ...prev.gaps,

                [this.taskIndex]: {

                    ...prev.gaps[this.taskIndex],

                    [gapId]: value

                }

            }

        }));

            const element =
                this.elements.get(gapId);

            if (!element) {
                return;
            }

            element.setModel(
                this.createGapModel(gapId)
            );

            element.update();

    }


    private createGapModel(
        gapId: number
    ): GapElementModel {

        const state = this.store.getState();

        const gap = this.task.gaps[gapId];

        return {

            taskIndex: this.taskIndex,

            gapId,

            answer: gap.value,

            length: gap.length,

            value:
                state.gaps[this.taskIndex]?.[gapId] ?? "",

            revealed:
                !!state.revealed[this.taskIndex],

            events: {

                valueChanged: (value: string) => {

                    this.updateGapValue(
                        gapId,
                        value
                    );

                }

            }

        };

    }

    private toggleReveal(): void {

        const state =
            this.store.getState();

        const isRevealed =
            !!state.revealed[this.taskIndex];

        this.store.update(prev => {

            if (isRevealed) {

                const {
                    [this.taskIndex]: _,
                    ...revealed
                } = prev.revealed;

                const {
                    [this.taskIndex]: __,
                    ...gaps
                } = prev.gaps;

                return {

                    ...prev,

                    revealed,

                    gaps

                };

            }

            return {

                ...prev,

                revealed: {

                    ...prev.revealed,

                    [this.taskIndex]: true

                }

            };

        });

        this.update();

    }

}